export default __webpack_public_path__ + "static/gab2-b67abebc0e10035ced1ae2d080a76d5d.png";